import { render } from "./HouseholdExpenseFlow.vue?vue&type=template&id=2871f2c9&scoped=true"
import script from "./HouseholdExpenseFlow.vue?vue&type=script&lang=js"
export * from "./HouseholdExpenseFlow.vue?vue&type=script&lang=js"

import "./HouseholdExpenseFlow.vue?vue&type=style&index=0&id=2871f2c9&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2871f2c9"]])

export default __exports__